import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Funder } from 'src/app/shared/models/funder';
import { User } from 'src/app/shared/models/security/user';
import { SortOrder } from '../../beneficiaires/list-beneficiaire/list-beneficiaire.component';
import { AddFunderModalComponent } from '../modal/add-funder-modal/add-funder-modal.component';
import { EditFunderModalComponent } from '../modal/edit-funder-modal/edit-funder-modal.component';

@Component({
	selector: 'app-list-funder',
	templateUrl: './list-funder.component.html',
	styleUrls: ['./list-funder.component.scss']
})
export class ListFunderComponent implements OnInit {
	funders: Funder[];
	currentPage = 1;
	itemsPerPage = 10;

	sortType = 'type';
	sortOrder: SortOrder = 'asc';

	dismissible: true;
	alerts: any[] = [];

	// nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	searchedText: string = '';

	editFunderModalRef: BsModalRef;
	addFunderModalRef: BsModalRef;

	// labelIntervention: string;
	isMobile: boolean = false;
	screenWidth: number;
	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getFunders();
		if (this.facade.dataStorageService.isPlanificatrice()) {
			this.isAddable = true;
		}

		// this.labelIntervention = this.facade.dataStorageService.getLabel(
		// 	PARAM_LABEL_INTERVENTION
		// );
	}

	getFunders(): void {
		this.facade.funderService.getAllFunders().subscribe({
			next: (funders: Funder[]) => {
				this.funders = funders;
				this.itemsPerPage = this.funders.length >= 10 ? 26 : 10;
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
			}
		});
	}

	openModalAjout() {
		this.addFunderModalRef = this.modalService.show(AddFunderModalComponent, {
			class: 'modal-lg',
			backdrop: 'static'
		});

		this.addFunderModalRef.onHide.subscribe((reason: string | any) => {
			this.getFunders();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(funder: Funder) {
		const initialState = {
			funder
		};
		this.editFunderModalRef = this.modalService.show(EditFunderModalComponent, {
			class: 'modal-lg',
			initialState
		});

		this.editFunderModalRef.onHide.subscribe((reason: string | any) => {
			this.getFunders();
		});
	}
}
